import React from 'react'
import { innerHtml } from '../../utils/innerHtml'
import WidthContainer from '../../elements/widthContainer'

const HtmlSection = ({ html }) => {
  return <WidthContainer variant="small">{innerHtml(html)}</WidthContainer>
}

export default HtmlSection
